var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsSystemThemeSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#E5E5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.58333 17C5.41806 17 5.27951 16.949 5.16771 16.8469C5.0559 16.7448 5 16.6183 5 16.4674C5 16.3165 5.0559 16.189 5.16771 16.0848C5.27951 15.9807 5.41806 15.9286 5.58333 15.9286H18.4167C18.5819 15.9286 18.7205 15.9796 18.8323 16.0817C18.9441 16.1838 19 16.3103 19 16.4612C19 16.6121 18.9441 16.7396 18.8323 16.8438C18.7205 16.9479 18.5819 17 18.4167 17H5.58333ZM6.94444 15.2143C6.62361 15.2143 6.34896 15.1094 6.12049 14.8996C5.89201 14.6897 5.77778 14.4375 5.77778 14.1429V8.07143C5.77778 7.77679 5.89201 7.52455 6.12049 7.31473C6.34896 7.10491 6.62361 7 6.94444 7H17.0556C17.3764 7 17.651 7.10491 17.8795 7.31473C18.108 7.52455 18.2222 7.77679 18.2222 8.07143V14.1429C18.2222 14.4375 18.108 14.6897 17.8795 14.8996C17.651 15.1094 17.3764 15.2143 17.0556 15.2143H6.94444ZM6.94444 14.1429H17.0556V8.07143H6.94444V14.1429Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsSystemThemeSelected);
export default __webpack_public_path__ + "static/media/settings_system_theme_selected.21bcd6336ee4f843b9052ce12ae67890.svg";
export { ForwardRef as ReactComponent };